"use strict";const e=require("./useBaseQuery-3fa1fdb3.js"),n=require("./QueryClientProvider-3971ad9a.js");function i(r,s,u){const t=n.parseQueryArgs(r,s,u);return e.useBaseQuery(t,e.QueryObserver)}exports.useQuery=i;
